export default __webpack_public_path__ + "static/media/leaderboardStar.038c99f3.svg";